import { Injectable } from '@angular/core';

import { CookieService } from 'ngx-cookie-service';
import { isEmpty, isNil } from 'lodash';

import { CookieConfig } from './../../models/cookie-config';
import { Configs } from './../../constants';

export const initialCookieConfigService: CookieConfig = { meterEntry: { ads: false, oko: { municipalities: [] } }, municipality: { key: '' } };

@Injectable({
  providedIn: 'root',
})
export class CookieConfigService implements CookieConfig {
  private _cookieConfig: CookieConfig;
  private _cookieName = Configs.EnergiePortal;

  constructor(private cookieService: CookieService) {
    this._cookieConfig = this.getAll(this._cookieName);
  }

  public get meterEntry(): { oko?: { municipalities: string[] }; ads?: boolean } {
    return this._cookieConfig.meterEntry;
  }

  public set meterEntry(meterEntry: { oko?: { municipalities: string[] }; ads?: boolean }) {
    this._cookieConfig.meterEntry = { ...this._cookieConfig.meterEntry, ...meterEntry };
    this.clearConfig();
    this.cookieService.set(this._cookieName, JSON.stringify(this._cookieConfig), 30);
  }

  public get municipality(): { key: string } {
    return this._cookieConfig.municipality;
  }

  public set municipality(municipality: { key: string }) {
    this._cookieConfig.municipality = municipality;
    this.clearConfig();
    this.cookieService.set(this._cookieName, JSON.stringify(this._cookieConfig), 30);
  }

  public setMunicipalityForOko(municipalityKey: string) {
    let meterEntry = this._cookieConfig.meterEntry;
    if (isEmpty(meterEntry.oko) && isNil(meterEntry.oko)) {
      this.meterEntry = { oko: { municipalities: [municipalityKey] } };
    } else {
      let okoMunicipalities = meterEntry.oko.municipalities;
      okoMunicipalities.push(municipalityKey);
      meterEntry.oko.municipalities = okoMunicipalities;
      this.meterEntry = meterEntry;
    }
  }

  private getAll(name: string): CookieConfig {
    if (isEmpty(this.cookieService.get(name))) {
      return initialCookieConfigService;
    } else {
      return JSON.parse(this.cookieService.get(name));
    }
  }
  private clearConfig() {
    if (this.cookieService.check(this._cookieName)) {
      this.cookieService.delete(this._cookieName);
    }
  }
}
